import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { waLink, telHref } from "../../lib/site";

export const Header = ({ content, hasServices, onHome = true }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const pre = onHome ? "" : "/";
  const links = [
    ["inicio", "Início"],
    ["acomodacoes", "Acomodações"],
    ["galeria", "Galeria"],
    ...(hasServices ? [["servicos", "Serviços"]] : []),
    ["localizacao", "Localização"],
    ["contato", "Contato"],
  ];
  const cta = waLink(content, content.whatsapp_message) || telHref(content.phone);

  return (
    <header data-testid="public-header" className={`fixed top-0 inset-x-0 z-40 transition-[background-color,border-color] duration-500 border-b ${scrolled || open ? "glass border-[#D4AF37]/15" : "bg-transparent border-transparent"}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-[72px] flex items-center justify-between gap-6">
        <a href={`${pre}#inicio`} data-testid="nav-logo" className="flex items-center shrink-0" aria-label="Vienna Palace Hotel — início">
          <img src="/img/logo-t.png" alt="Vienna Palace Hotel" className="h-12 sm:h-14 w-auto" width="108" height="56" />
        </a>
        <nav className="hidden lg:flex items-center gap-8" aria-label="Menu principal">
          {links.map(([id, label]) => (
            <a key={id} href={`${pre}#${id}`} data-testid={`nav-link-${id}`} className="text-[13px] tracking-[0.12em] uppercase text-zinc-300 hover:text-[#E6C687] transition-colors">
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={cta} target="_blank" rel="noopener noreferrer" data-testid="nav-cta-availability" className="btn-gold !py-2.5 !px-5 hidden sm:inline-flex">
            {content.btn_nav_cta}
          </a>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="lg:hidden h-11 w-11 grid place-items-center rounded-full border border-[#D4AF37]/30 text-[#E6C687]" aria-label="Abrir menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden absolute inset-x-0 top-full h-[calc(100svh-72px)] overflow-y-auto bg-black border-t border-[#D4AF37]/10 px-5 pb-8 pt-4">
          {links.map(([id, label], i) => (
            <a key={id} href={`${pre}#${id}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${id}`} className="reveal block py-3.5 font-display text-2xl text-zinc-100 border-b border-zinc-800/70" style={{ animationDelay: `${i * 40}ms` }}>
              {label}
            </a>
          ))}
          <div className="mt-6 grid gap-3">
            <a href={cta} target="_blank" rel="noopener noreferrer" data-testid="mobile-nav-cta" className="btn-gold w-full">{content.btn_nav_cta}</a>
            <a href={telHref(content.phone)} data-testid="mobile-nav-phone" className="btn-outline-gold w-full"><Phone size={16} /> {content.phone}</a>
          </div>
        </div>
      )}
    </header>
  );
};
